import { AxiosRequestHeaders } from 'axios';
import { api } from '.';

let headers: AxiosRequestHeaders;

// *******************************************************
//* inject accessToken in the header if it exists
//* ******************************************************
const accessToken = sessionStorage.getItem('access_token');
if (accessToken) {
    headers = { Authorization: `Bearer ${accessToken}` };
}

const requestInter = () =>
    api.interceptors.request.use(config => {
        config.headers = { ...config.headers, ...headers };
        return config;
    });

export default requestInter;
